import React, { FC, useEffect, useState } from "react";
import { jsx } from "@emotion/react";
import JSX = jsx.JSX;
import { Popover, PopoverOrigin } from "@mui/material";
import "./TelescopePopover.scss";
import { Close } from "@mui/icons-material";
type Props = {
  children?: JSX.Element;
  popOverContent: JSX.Element;
  buttonClassName?: string;
  autoDismiss?: boolean;
  closeClickPopover?: boolean;
  resetOpenState?: () => void;
  anchorOrigin?: PopoverOrigin;
  transformOrigin?: PopoverOrigin;
  initialAnchorEl?: HTMLElement;
  removeBackdrop?: boolean;
  closeIcon?: boolean;
};

const TelescopePopover: FC<Props> = ({
  children,
  popOverContent,
  buttonClassName,
  autoDismiss = false,
  anchorOrigin,
  transformOrigin,
  closeClickPopover = false,
  resetOpenState,
  initialAnchorEl,
  removeBackdrop,
  closeIcon,
}) => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const open = Boolean(anchorEl);
  useEffect(() => {
    handleClose();
  }, [initialAnchorEl]);

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
    if (resetOpenState) resetOpenState();
  };

  useEffect(() => {
    if (closeClickPopover) {
      handleClose();
    }
  }, [closeClickPopover]);

  return (
    <div>
      {children && (
        <button
          id="idpopover"
          className={`${buttonClassName} popover-button`}
          role={"button"}
          onClick={handleClick}
        >
          {children}
        </button>
      )}
      <Popover
        hideBackdrop={removeBackdrop}
        container={initialAnchorEl}
        id={"idpopover"}
        anchorOrigin={
          anchorOrigin ? anchorOrigin : { vertical: 40, horizontal: 0 }
        }
        open={Boolean(initialAnchorEl) || open}
        onClose={() => handleClose()}
        anchorEl={initialAnchorEl || anchorEl}
        transformOrigin={transformOrigin}
        className={removeBackdrop ? "hide-backdrop" : ""}
        onClick={autoDismiss ? () => handleClose() : () => {}}
      >
        <div>
          {closeIcon && (
            <div className="popover-close-icon">
              <span onClick={() => handleClose()}>
                <Close />
              </span>
            </div>
          )}
          {popOverContent}
        </div>
      </Popover>
    </div>
  );
};
export default TelescopePopover;
